import React from 'react'
import './Brand.css'
import { useTranslation } from 'react-i18next';

const Brand = () => {
  const { t } = useTranslation();

  return (
    <section>
        <div className="container-fluid px-md-5 px-3">
            <h4 className='section-suptitle'>{t('brand.title')}</h4>
            <p className='section-desc w-100 mb-4'>{t('brand.desc')}</p>
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="blog-img position-relative">
                <div className="blog-featured px-4 rounded-pill bg-white py-1">{t('brand.featured')}</div>
                <div className="blog-bottom w-100 px-4">
                    <h2 className='mb-5 blog-title'>{t('brand.blog1')}</h2>
                    <div className="d-flex justify-content-end">
                        <span className='blog-date mb-3'>02 May</span>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                        <img src="Avatar-2.png" className='img-fluid' alt="man" />
                        <div>
                            <h5 className='blog-name'>Viola Manisa</h5>
                            <div className="d-flex gap-2 align-items-center">
                                <img src="Icon-3.svg" alt="check" />
                                <h5 className='m-0 blog-job'>{t('brand.verified_writer')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="blog-1.png" className='img-fluid rounded-3 blog-img' alt="blog" />
            </div>
          </div>
          <div className="col-md-6 mb-3">
            <div className="blog-img position-relative">
                <div className="blog-featured px-4 rounded-pill bg-white py-1">{t('brand.featured')}</div>
                <div className="blog-bottom w-100 px-4">
                    <h2 className='mb-5 blog-title'>{t('brand.blog2')}</h2>
                    <div className="d-flex justify-content-end">
                        <span className='blog-date mb-3'>02 May</span>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                        <img src="Avatar-1.png" className='img-fluid' alt="man" />
                        <div>
                            <h5 className='blog-name'>Joshua William</h5>
                            <div className="d-flex gap-2 align-items-center">
                                <img src="Icon-3.svg" alt="check" />
                                <h5 className='m-0 blog-job'>{t('brand.verified_writer')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="blog-2.png" className='img-fluid rounded-3 blog-img' alt="blog" />
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="blog-img position-relative">
                <div className="blog-bottom w-100 px-4">
                    <h2 className='mb-3 blog-title-2'>{t('brand.blog3.title')}</h2>
                    <p className='blog-desc'>{t('brand.blog3.desc')}</p>
                    <div className="d-flex justify-content-end">
                        <span className='blog-date mb-3'>02 May</span>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                        <img src="Avatar.png" className='img-fluid' alt="man" />
                        <div>
                            <h5 className='blog-name'>Lina Hicks</h5>
                            <div className="d-flex gap-2 align-items-center">
                                <img src="Icon-3.svg" alt="check" />
                                <h5 className='m-0 blog-job'>{t('brand.verified_writer')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="blog-3.png" className='img-fluid rounded-3 blog-img' alt="blog" />
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="blog-img position-relative">
            <div className="blog-bottom w-100 px-4">
                    <h2 className='mb-3 blog-title-2'>{t('brand.blog4.title')}</h2>
                    <p className='blog-desc'>{t('brand.blog4.desc')}</p>
                    <div className="d-flex justify-content-end">
                        <span className='blog-date mb-3'>02 May</span>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                        <img src="Avatar-1.png" className='img-fluid' alt="man" />
                        <div>
                            <h5 className='blog-name'>Tyler Murray</h5>
                            <div className="d-flex gap-2 align-items-center">
                                <img src="Icon-3.svg" alt="check" />
                                <h5 className='m-0 blog-job'>{t('brand.verified_writer')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="blog-4.png" className='img-fluid rounded-3 blog-img' alt="blog" />
            </div>
          </div>
          <div className="col-md-4 mb-3">
            <div className="blog-img position-relative">
            <div className="blog-bottom w-100 px-4">
                    <h2 className='mb-3 blog-title-2'>{t('brand.blog5.title')}</h2>
                    <p className='blog-desc'>{t('brand.blog5.desc')}</p>
                    <div className="d-flex justify-content-end">
                        <span className='blog-date mb-3'>02 May</span>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                        <img src="Avatar-2.png" className='img-fluid' alt="man" />
                        <div>
                            <h5 className='blog-name'>Warren Casey</h5>
                            <div className="d-flex gap-2 align-items-center">
                                <img src="Icon-3.svg" alt="check" />
                                <h5 className='m-0 blog-job'>{t('brand.verified_writer')}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <img src="blog-5.png" className='img-fluid rounded-3 blog-img' alt="blog" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Brand
